export default "__VITE_ASSET__BL5KJrIc__"